import React from 'react';
import { useTranslation } from 'react-i18next';
import V2Layout from '../components/V2Layout';
import useV2Auth from '../hooks/useV2Auth';
import SupportIcon from '../../assets/Icons/SupportIcon.svg?react';

const MANAGER_TELEGRAM_URL = 'https://t.me/fishh_support';

const AUDIENCE_KEYS = [
  'cooperation_audience_coach',
  'cooperation_audience_school',
  'cooperation_audience_fund',
  'cooperation_audience_streamer',
  'cooperation_audience_blogger',
  'cooperation_audience_affiliate',
] as const;

const V2Cooperation: React.FC = () => {
  const { t } = useTranslation('translation');
  const { user } = useV2Auth();
  const [compact, setCompact] = React.useState(false);

  return (
    <V2Layout
      activeNav="profile"
      compact={compact}
      onToggleCompact={() => setCompact((value) => !value)}
      userEmail={user?.email}
      breadcrumbs={
        <p className="breadcrumbs">
          Партнёрство <span>/</span> <strong>Сотрудничество</strong>
        </p>
      }
      footerNote="Сотрудничество"
    >
      <section className="player-heading player-heading--page">
        <div>
          <div className="player-title-line">
            <h1>{t('cooperation_title')}</h1>
          </div>
          <p className="profile-description">{t('cooperation_hero_subtitle')}</p>
        </div>
      </section>

      <div className="content-stack cooperation-stack">
        <section className="surface-card">
          <p className="body-text">{t('cooperation_intro')}</p>
          <div className="cooperation-audience">
            {AUDIENCE_KEYS.map((key) => (
              <span key={key} className="cooperation-audience__tag">
                {t(key)}
              </span>
            ))}
          </div>
        </section>

        <section className="surface-card">
          <div className="block-heading">
            <h2>{t('cooperation_offer_title')}</h2>
          </div>
          <p className="body-text">{t('cooperation_offer_text')}</p>
        </section>

        <section className="subscription-cta cooperation-cta">
          <span className="subscription-cta__icon" aria-hidden="true">
            <SupportIcon />
          </span>
          <div>
            <h2>{t('cooperation_cta_title')}</h2>
            <p className="body-text">
              {t('cooperation_cta_prefix')}{' '}
              <a href={MANAGER_TELEGRAM_URL} target="_blank" rel="noopener noreferrer">
                {t('cooperation_cta_manager')}
              </a>{' '}
              {t('cooperation_cta_suffix')}
            </p>
          </div>
          <a
            className="acid-button"
            href={MANAGER_TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('cooperation_cta_button')} <span aria-hidden="true">↗</span>
          </a>
        </section>
      </div>
    </V2Layout>
  );
};

export default V2Cooperation;
